import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(id: string) {
    const response = await api.fetch(
      `/api/v2/invoice/index/id_reservation/${id}`,
    )
    return await handleResponse(response)
  }
}
